import { useSelector } from "react-redux";
import { useMemo } from "react";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { CareRecipient } from "../../../domain/care_recipient/CareRecipient";
import { CareRecipientName } from "../../../domain/care_recipient/CareRecipientName";
import { DateObject } from "../../../domain/fundamental/DateObject";
import { CareRecipientHouseId } from "../../../domain/care_recipient/CareRecipientHouseId";
import { State } from "../../../state/store";
import { CustomerCode } from "../../../domain/care_recipient/CustomerCode";
import { BranchCode } from "../../../domain/care_recipient/BranchCode";

export const useCareRecipientInformation = (): CareRecipient | null => {
    const informationJson = useSelector((state: State) => state.careRecipient.careRecipientInformation);

    // コンポーネントでのuseEffect無限ループ対策
    const infomation = useMemo(() => {
        return informationJson ?
            CareRecipient.from(
                CareRecipientId.fromString(informationJson.id),
                CareRecipientName.fromString(informationJson.name),
                DateObject.fromString(informationJson.birthday),
                informationJson.houseId ? CareRecipientHouseId.fromString(informationJson.houseId) : null,
                informationJson.customerCode ? CustomerCode.fromString(informationJson.customerCode) : null,
                informationJson.branchCode ? BranchCode.fromString(informationJson.branchCode) : null,
            ) : null;
    }, [informationJson]);

    return infomation;
};
